import * as React from 'react';
import { connect } from 'react-redux';

import { CheckboxField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { changePromoCheckbox } from '../../../state/advanced/developer';
import { InlineParam } from '../markup';

interface IPromoProps {
  promo: boolean;
  onChangedPromo(value: boolean): void;
}

const promo: React.StatelessComponent<IPromoProps> = props => {
  return (
    <InlineParam>
      <CheckboxField
        label={'Скидки и акции'}
        value={props.promo}
        onValueChange={value => props.onChangedPromo(value)}
      />
    </InlineParam>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    promo: (state.filters.jsonQuery.promo && state.filters.jsonQuery.promo.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onChangedPromo: (value: boolean) => {
      dispatch(changePromoCheckbox(value));
    },
  }),
)(promo);
